import { ProfileForm } from './ProfileForm'

export default ProfileForm
